export const downloadFile = (data: Blob, filename?: string) => {
  const navigatorAs = window.navigator as any;
  if (navigatorAs?.msSaveOrOpenBlob) {
    // for IE
    navigatorAs.msSaveOrOpenBlob(data, filename);
  } else {
    const downloadUrl = window.URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", filename || "");
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
};
